import React from "react";

import { Trash} from "react-bootstrap-icons";

import { getNotchIcon } from 'services/notches';

function FavoritesList({
    items = [],
    onClickHandler,
    onDeleteHandler
}) {
    return (
        <ul className="list-group list-group-flush w-100">
            {items.map(item => (
                <li
                    key={item.uid}
                    className="list-group-item w-100 p-1"
                    style={{ 
                        // cursor: "pointer", 
                        display: 'flex', 
                        alignItems: 'stretch' 
                    }}
                >
                    <div style={{
                        width: '4px',
                        minHeight: '100%',
                        background: item.color,
                        flexShrink: 0
                    }} />

                    <div style={{ 
                        flex: 1, 
                        padding: '4px' 
                    }}>
                        <div className="d-flex align-items-center">
                            {getNotchIcon(item.type, {
                                color: item.color ?? null,
                                size: 18
                            })}

                            <span className="flex-grow-1">{item.notch}</span>

                            {onDeleteHandler && (<button
                                type="button"
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => onDeleteHandler(item.uid)}
                            >
                                <Trash size={16} />
                            </button>)}
                        </div>
                    </div>
                </li>
            ))}
        </ul>
    );
};

export default FavoritesList;